// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__30lqz","productName":"Table_productName__3UL1F"};